import { CommonConstant } from '../../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { ObjectUtils } from '../../../../utils/object.utils';
import { UserService } from '../../../../services/user.service';
var InfluencerTopExposuresComponent = /** @class */ (function () {
    function InfluencerTopExposuresComponent(translate, pdfService, userService) {
        this.translate = translate;
        this.pdfService = pdfService;
        this.userService = userService;
        this.topExposures = [];
        this.platformList = [];
        this.forPayingUser = false;
    }
    InfluencerTopExposuresComponent.prototype.ngOnInit = function () {
    };
    InfluencerTopExposuresComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.topExposures.length === 0) {
            this.pdfService.incrementNumberReportReady(InfluencerTopExposuresComponent.COMPONENT_NAME);
        }
        else {
            this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
                if (data.component === InfluencerTopExposuresComponent.COMPONENT_NAME
                    && data.currentCounter === _this.topExposures.length) {
                    _this.pdfService.incrementNumberReportReady(InfluencerTopExposuresComponent.COMPONENT_NAME);
                }
            });
        }
    };
    InfluencerTopExposuresComponent.prototype.getExposureType = function (exposureIndex) {
        switch (exposureIndex) {
            case CommonConstant.REACH_EXPOSURE_INDEX:
                return this.translate.instant('INFLUENCER.insight.top_exposure.reach');
            case CommonConstant.ENGAGEMENT_EXPOSURE_INDEX:
                return this.translate.instant('INFLUENCER.insight.top_exposure.engagement');
            case CommonConstant.IMPACT_EXPOSURE_INDEX:
                return this.translate.instant('INFLUENCER.insight.top_exposure.impact');
        }
    };
    Object.defineProperty(InfluencerTopExposuresComponent.prototype, "hasNoData", {
        get: function () {
            if (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin) {
                return true;
            }
            if (this.topExposures.length === 0) {
                return true;
            }
            var noneEmptyExposures = this.topExposures.filter(function (te) { return !ObjectUtils.isEmpty(te); });
            return noneEmptyExposures.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerTopExposuresComponent.COMPONENT_NAME = 'TopExposuresComponent';
    return InfluencerTopExposuresComponent;
}());
export { InfluencerTopExposuresComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposures.component.ts.pre-build-optimizer.js